export default "__VITE_ASSET__FZ0QX$VG__"